export function klingReleaseDiff(active,draft){
 const before=(active?.draft.rows||[]).filter(r=>r.open),after=(draft.rows||[]).filter(r=>r.open);
 const key=r=>`${r.mode}/${r.resolution}/${r.audio}`;
 const keys=[...new Set([...before,...after].map(key))];
 return keys.map(id=>{const old=before.find(r=>key(r)===id),next=after.find(r=>key(r)===id);return {...(next||old),key:id,before:old?.price,after:next?.price,nextCost:next?.cost,change:!next?'关闭':!old?(active?'新增开放':'切换至按秒计费'):old.price!==next.price||old.cost!==next.cost?'调价':'保持'};});
}
